import { supabase } from '../integrations/supabase/client';

export interface UserProfile {
  readonly id: string;
  readonly full_name: string | null;
  readonly username: string | null;
  readonly avatar_url: string | null;
  readonly updated_at: string | null;
  readonly role: string | null;
  readonly first_name?: string | null;
  readonly last_name?: string | null;
}

export async function fetchUserProfile(userId: string): Promise<UserProfile | null> {
  try {
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('first_name, last_name, avatar_url, updated_at')
      .eq('user_id', userId)
      .is('organization_id', null)
      .maybeSingle()
      .overrideTypes<{
        first_name: string | null;
        last_name: string | null;
        avatar_url: string | null;
        updated_at: string | null;
      }>();

    if (profileError) {
      throw new Error('Profile request failed');
    }

    const { data: userRole, error: roleError } = await supabase
      .from('user_role_assignments')
      .select('role')
      .eq('user_id', userId)
      .maybeSingle()
      .overrideTypes<{ role: string }>();

    if (roleError) {
      throw new Error('Role request failed');
    }

    return {
      id: userId,
      first_name: profile?.first_name ?? null,
      last_name: profile?.last_name ?? null,
      full_name: profile
        ? `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || null
        : null,
      username: null,
      avatar_url: profile?.avatar_url || null,
      updated_at: profile?.updated_at || null,
      role: userRole?.role ?? null,
    };
  } catch {
    throw new Error('User profile is temporarily unavailable');
  }
}
